<!-- Main Container -->
<div class="card p-4" style="height: auto">
  <!-- Header -->
  <div class="px-4 py-2 border-b border-gray-200 dark:border-gray-700 mb-4">
    <h3 class="text-lg font-semibold text-gray-800 dark:text-gray-100">
      Bookmarked Transactions
    </h3>
  </div>

  <!-- Grid Wrapper -->
  <div class="grid-wrapper">
    <div *ngIf="view" class="k-i-loading"></div>
    <kendo-grid
      [loading]="pendingSpinner"
      [kendoGridBinding]="view"
      [selectable]="true"
      [rowSelected]="isRowSelected"
      kendoGridSelectBy="blotterId"
      [height]="730"
      [pageSize]="gridState.take"
      [skip]="gridState.skip"
      [sort]="gridState.sort"
      [resizable]="true"
      [filterable]="true"
      [sortable]="true"
      [navigable]="true"
      (sortChange)="sortChange($event)"
      [pageable]="
        asPageable({
          buttonCount: buttonCount,
          info: info,
          type: type,
          pageSizes: pageSizes,
          previousNext: previousNext
        })
      "
    >
      <kendo-grid-column
        [width]="40"
        field="bookm"
        [filterable]="false"
        title=""
      >
        <ng-template kendoGridCellTemplate let-dataItem>
          <span *ngIf="dataItem.bookm !== null">
            <a
              (click)="bookMarksremoved(dataItem.bookm)"
              routerLinkActive="router-link-active"
            >
              <ng-icon name="heroBookmarkSolid" class="text-blue-600"></ng-icon>
            </a>
          </span>
        </ng-template>
      </kendo-grid-column>

      <kendo-grid-column field="blotterId" title="ID" [width]="100" [filterable]="true"></kendo-grid-column>
      <kendo-grid-column field="repName" title="Rep Name" [width]="110"></kendo-grid-column>
      <kendo-grid-column field="accountName" title="Account" [width]="150">
        <ng-template kendoGridCellTemplate let-dataItem>
          <div
            class="selectable text-blue-600 cursor-pointer"
            title="View/Edit Account"
            (click)="viewClientInfo(dataItem.clientId)"
          >
            {{ dataItem.accountName }}
          </div>
        </ng-template>
      </kendo-grid-column>
      <kendo-grid-column field="productTypeDesc2" title="Product" [width]="120"></kendo-grid-column>
      <kendo-grid-column field="sponsorName" title="Sponsor" [width]="80"></kendo-grid-column>
      <kendo-grid-column field="productName" title="Product Name" [width]="120"></kendo-grid-column>
      <kendo-grid-column field="transactionTypeDesc" title="Trans Type" [width]="100"></kendo-grid-column>
      <kendo-grid-column field="amount" format="{0:c}" title="Amount" [width]="120"></kendo-grid-column>
      <kendo-grid-column field="dateSubmitted" title="Date Submitted" [width]="120">
        <ng-template kendoGridCellTemplate let-column>
          {{ column.dateSubmitted | date : 'MM/dd/yyyy' }}
        </ng-template>
      </kendo-grid-column>

      <kendo-grid-column field="statusTypeDesc" title="Status" [width]="150">
        <ng-template kendoGridCellTemplate let-dataItem>
          <span *ngIf="dataItem.statusTypeId === 0">
            {{ dataItem.statusTypeDesc }}
          </span>
          <span *ngIf="dataItem.statusTypeId === 5">Pending - preliminary review complete</span>
          <span *ngIf="dataItem.statusTypeId === 1">Submitted for Review</span>
          <span *ngIf="dataItem.statusTypeId === -2">
            <kendo-dropdownlist
              [data]="dropdownStatusLight"
              [valuePrimitive]="true"
              (valueChange)="handleOrderChange(dataItem.statusTypeId, dataItem.blotterId)"
              [(ngModel)]="dataItem.statusTypeId"
              textField="text"
              valueField="value"
              [popupSettings]="{ width: 250, height: 150 }"
              class="text-xs w-40"
            ></kendo-dropdownlist>
          </span>
        </ng-template>
      </kendo-grid-column>

      <!-- Action Columns -->
      <kendo-grid-column [width]="40" [hidden]="hidebyRole">
        <ng-template kendoGridCellTemplate let-dataItem>
          <div *ngIf="dataItem.showReviewTransaction">
            <a class="icon-btn" (click)="ReviewTransactionsview(
              dataItem.blotterId,
              dataItem.clientId,
              dataItem.repId,
              dataItem.clientName,
              dataItem.statusTypeId,
              dataItem.transactionTypeId,
              dataItem.productTypeId,
              dataItem.showReviewTransaction,
              dataItem.showAccountReview
            )" title="Review Summary">
              <ng-icon name="heroEye" class="xl"></ng-icon>
            </a>
          </div>
        </ng-template>
      </kendo-grid-column>

      <kendo-grid-column [width]="40" [hidden]="hidebyRole">
        <ng-template kendoGridCellTemplate let-dataItem>
          <div *ngIf="dataItem.accountFormReviewCount > 0 && dataItem.statusTypeId > -2 && dataItem.newAccountForm === 'On File' && dataItem.blotterId > 0">
            <a class="icon-btn" (click)="openForm(dataItem)" title="Account Form Report">
              <ng-icon name="heroMagnifyingGlass" class="xl"></ng-icon>
            </a>
          </div>
        </ng-template>
      </kendo-grid-column>

      <kendo-grid-column [width]="40" [hidden]="hidebyRole">
        <ng-template kendoGridCellTemplate let-dataItem>
          <div *ngIf="dataItem.showAccountReview">
            <a class="icon-btn" (click)="ReviewAccountTransactionsview(
              dataItem.blotterId,
              dataItem.clientId,
              dataItem.repId,
              dataItem.clientName,
              dataItem.statusTypeId,
              dataItem.transactionTypeId,
              dataItem.productTypeId,
              dataItem.showReviewTransaction,
              dataItem.showAccountReview
            )" title="Account Form Review">
              <ng-icon name="heroArchiveBox" class="xl"></ng-icon>
            </a>
          </div>
        </ng-template>
      </kendo-grid-column>

      <kendo-grid-column title="" [width]="40" [hidden]="hidebyRole" [sticky]="true">
        <ng-template kendoGridCellTemplate let-dataItem>
          <a class="icon-btn" (click)="EditTransactions(
            dataItem.blotterId,
            dataItem.clientId,
            dataItem.repId,
            dataItem.clientName,
            dataItem.statusTypeId,
            dataItem.transactionTypeId,
            dataItem.productTypeId,
            dataItem.showReviewTransaction,
            dataItem.showAccountReview,
            dataItem.state
          )" routerLinkActive="router-link-active" title="Edit Transaction">
            <ng-icon name="heroPencil" class="xl"></ng-icon>
          </a>
        </ng-template>
      </kendo-grid-column>

      <kendo-grid-column [width]="40" #lastColumn>
        <ng-template kendoGridCellTemplate let-dataItem>
          <a class="icon-btn" (click)="viewFiles(
            dataItem.repId,
            dataItem.clientName,
            dataItem.blotterId,
            dataItem.clientId,
            'blotterId'
          )" routerLinkActive="router-link-active" title="View Files">
            <ng-icon name="heroFolder" class="xl"></ng-icon>
          </a>
        </ng-template>
      </kendo-grid-column>
    </kendo-grid>

    <!-- Dialog: Print Receipt -->
    <kendo-dialog animate="animates" (close)="onDialogReciptClose()" *ngIf="openAccountReadOnly" [minWidth]="250" [width]="550">
      <kendo-dialog-titlebar>
        <div class="text-lg font-medium flex items-center space-x-2">
          <span class="k-icon k-i-print"></span> Print Receipt
        </div>
      </kendo-dialog-titlebar>
      <div class=" dark:bg-gray-800 p-2">
        <gd-pdfsavior [RepNamInfo]="RepNamInfo" [blotterId]="blotterComment"></gd-pdfsavior>
      </div>
      <kendo-dialog-actions>
        <button kendoButton (click)="onDialogReciptClose()" class="w-full">Close Window</button>
      </kendo-dialog-actions>
    </kendo-dialog>
  </div>
</div>
